import { render, staticRenderFns } from "./RiskReassessmentCsvUploadDialog.vue?vue&type=template&id=bf78e152"
import script from "./RiskReassessmentCsvUploadDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RiskReassessmentCsvUploadDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports